import React from "react";
import { GlobalMessageList, GlobalMessageItem } from "./GlobalMessageItems";
import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  IResponseMessageUI,
  MessageType,
  removeMessage,
} from "../../../lib/store/reducers/responseMessagesReducer";

import styles from "./ResponseMessage.module.css";


interface GlobalMessagesProps {
  responseMessages: IResponseMessageUI[];
  onClearMessage: (message: IResponseMessageUI) => void;
  mode?: "STANDARD" | "WAREHOUSE"; 
}
const GlobalMessages = ({
  responseMessages,
  onClearMessage,
  mode = "STANDARD",
}: GlobalMessagesProps) => {

  const currentMessage: IResponseMessageUI | undefined = useMemo(() => {
    if (mode === "WAREHOUSE") {
      return responseMessages.find(
        (msg) => msg.messageType === MessageType.WAREHOUSE
      );
    } else {
      const standardMessages = responseMessages.filter(
        (msg) => msg.messageType !== MessageType.WAREHOUSE
      );
      return standardMessages.length > 0 ? standardMessages[standardMessages.length - 1] : undefined;
    }
  }, [responseMessages, mode]);

  const [triggerOutAnimation, setTriggerOutAnimation] = useState(false);
  const [previousTriggerFinished, setPreviousTriggerFinished] = useState(true);

  const onConfirmHandler = () => {
    if (!previousTriggerFinished) return;
    setPreviousTriggerFinished(false);
    setTriggerOutAnimation(true);
  };

  const onAnimationEndHandler = async () => {
    
        if (currentMessage) {
      onClearMessage(currentMessage);
    }
    setPreviousTriggerFinished(true);
    setTriggerOutAnimation(false);
  };

  if (!currentMessage) return null;


  const containerClass = mode === "WAREHOUSE" 
    ? styles["warehouse-message-list"] 
    : styles["global-message-list"];

  return (
    <>
      
      <GlobalMessageList className={containerClass}>
        {currentMessage && (
          <GlobalMessageItem
            message={currentMessage}
            isPendingRemoval={triggerOutAnimation}
            onAnimationEnd={onAnimationEndHandler}
            onConfirm={onConfirmHandler}
          />
        )}
      </GlobalMessageList>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    responseMessages: state.responseMessages,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClearMessage: (message: IResponseMessageUI) => dispatch(removeMessage(message.id)),
});


export default connect(mapStateToProps, mapDispatchToProps)(GlobalMessages);
